<template>
  <path
    d="M20 3.00018H6C4.9 3.00018 4 3.90018 4 5.00018V13.0002C4 15.2102 5.79 17.0002 8 17.0002H14C16.21 17.0002 18 15.2102 18 13.0002V10.0002H20C21.1 10.0002 22 9.10018 22 8.00018V5.00018C22 3.90018 21.1 3.00018 20 3.00018ZM20 8.00018H18V5.00018H20V8.00018ZM3 21.0002H19C19.55 21.0002 20 20.5502 20 20.0002C20 19.4502 19.55 19.0002 19 19.0002H3C2.45 19.0002 2 19.4502 2 20.0002C2 20.5502 2.45 21.0002 3 21.0002Z"
  />
</template>
